import { defineNuxtPlugin } from '#app'
import { createI18n } from 'vue-i18n'
import en from '~/locales/en.json'
import ar from '~/locales/ar.json'

export default defineNuxtPlugin(({ vueApp }) => {
  // Load saved language from localStorage or default to 'en'
  let savedLocale = 'en'
  if (typeof window !== 'undefined') {
    savedLocale = localStorage.getItem('userLanguage') || 'en'
  }

  const i18n = createI18n({
    legacy: false,
    globalInjection: true,
    locale: savedLocale,
    fallbackLocale: 'en',
    messages: {
      en,
      ar
    }
  })

  vueApp.use(i18n)

  return {
    provide: {
      i18n: i18n.global
    }
  }
})
